import {InputText, Select} from '@/components/Form/index.mjs'
import FormItemBizProp from '../components/FormItemBizProp.jsx'
import FormChooseDesign from '../_DESIGN/FormChooseDesign.jsx'
import Model from './ModelMid.mjs'
import useMidType from './useMidType.mjs'

export const FormItemMiddlewareName = props => (
    <FormItemBizProp
        Model={Model}
        prop="middlewareName"
        {...props}
    >
        <InputText allowClear />
    </FormItemBizProp>
)

export const FormItemMiddlewareType = props => {
    const {pairs: midTypePairs} = useMidType()

    return (
        <FormItemBizProp
            Model={Model}
            prop="middlewareType"
            {...props}
        >
            <Select
                allowClear
                getOptionKey={e => e[0]}
                getOptionLabel={e => e[1].middlewareTypeName}
                options={midTypePairs}
            />
        </FormItemBizProp>
    )
}

export default function FormChooseMid(props) {
    return (
        <FormChooseDesign {...props}>
            <FormItemMiddlewareName />
            <FormItemMiddlewareType />
        </FormChooseDesign>
    )
}
